import { toZonedTime } from '@expane/date'
import { queryClient } from '../../../api'
import { TRANSACTIONS_QUERY_KEY } from '../queryKeys'

export * from './transactionTypes'

export const invalidateTransactions = () => {
  queryClient.invalidateQueries({
    predicate: query => query.queryKey.includes(TRANSACTIONS_QUERY_KEY),
  })
}

export const invalidateTransactionsById = (ids: number[] | undefined) => {
  if (ids) {
    for (const transactionId of ids) {
      queryClient.invalidateQueries({
        predicate: query =>
          query.queryKey.includes(TRANSACTIONS_QUERY_KEY) && query.queryKey.includes(transactionId),
      })
    }
  }
}

export type TransactionToParse = {
  date?: string | Date | null
  startPeriod?: string | Date | null
  endPeriod?: string | Date | null
}
export const parseDatesInTransactionGqlResponse = <T extends TransactionToParse>(
  transaction: T,
  timezone: string,
) => {
  if (transaction.date) {
    transaction.date = toZonedTime(transaction.date, timezone)
  }
  if (transaction.startPeriod) {
    transaction.startPeriod = toZonedTime(transaction.startPeriod, timezone)
  }
  if (transaction.endPeriod) {
    transaction.endPeriod = toZonedTime(transaction.endPeriod, timezone)
  }

  return transaction
}
